import {NgModule} from "@angular/core";
import {SharedModule} from "../shared/shared.module";
import {CollectionSearchComponent} from "./collection-search.component";
import {CaCollectionFilterComponent} from "./components/filters/ca-collection-filter/ca-collection-filter.component";
import {HlaCollectionFilterComponent} from "./components/filters/hla-collection-filter/hla-collection-filter.component";
import {CollectionFilterProxyComponent} from "./components/form-controls/collection-filter-proxy/collection-filter-proxy.component";

@NgModule({
    declarations: [
        CollectionSearchComponent,
        CollectionFilterProxyComponent,
        CaCollectionFilterComponent,
        HlaCollectionFilterComponent
    ],
    imports: [
        SharedModule
    ],
    entryComponents: [
        CaCollectionFilterComponent,
        HlaCollectionFilterComponent
    ]
})
export class CollectionSearchModule {
}
